var _path, _path2, _path3, _circle, _path4, _path5, _ellipse, _circle2, _ellipse2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNcl = function SvgNcl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 426.7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009543",
    d: "M0 293h640v133.7H0V293z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED4135",
    d: "M0 132h640v161.3H0V132z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0035AD",
    d: "M0 0h640v133.3H0V0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FAE600",
    stroke: "#000",
    strokeWidth: 5.3,
    cx: 240,
    cy: 213.3,
    r: 157.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M307.9 354.5l-31.8 12-36.1 4.2-37.8-2.4-35.9-15.5s28.6-29.3 40.7-33.5c8.6-3 22.4-3.7 22.4-3.7V122l-.3-66H246l-.5 67.5v191.7s15.3 1.2 22.1 4.1c11.3 4.9 40.3 35.2 40.3 35.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.727 102.375l42.955-21.418 5.577 11.187-42.955 21.417z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 237.8,
    cy: 280.5,
    rx: 16.8,
    ry: 26.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.4,
    cy: 143.4,
    r: 20.9
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 238.4,
    cy: 211.1,
    rx: 19.9,
    ry: 12.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M213.8 177h47v10h-47zm0 57h47v10h-47z"
  })));
};
export { SvgNcl as ReactComponent };